export default __webpack_public_path__ + "static/media/shuffling-cards-1.30ba20ce.mp3";